import { h } from 'preact';

import capitalize from '../utils/capitalize';

const EmptyContest = ({ party }) => {
  const partyProper = capitalize(party);
  return (
    <div class="contest contest--empty">
      <div class="contest__caption">
        <p class="contest__caption-title">{partyProper} Primary</p>
        <p class="contest__caption_explainer">{`No ${partyProper} candidates`}</p>
      </div>
    </div>
  );
};

export default EmptyContest;



// WEBPACK FOOTER //
// ./components/EmptyContest.js